<template>
<v-data-table no-data-text="اطلاعاتی موجود نیست" :headers="headers" :items="data" disable-pagination :hide-default-footer="true" fixed-header item-key="_id" :single-select="singleSelect" :show-select="showSelect" v-model="selected"
  :expanded.sync="expanded" :single-expand="singleExpand" :show-expand="true">
  <template v-slot:[`item.price`]="{ item }">
    <span>{{ Math.abs(item.price).toLocaleString() }}</span>
  </template>
  <template v-slot:expanded-item="{ item }">
    <td :colspan="3" v-if="item && item.bank_account[0]">
      شماره حساب : {{ item.bank_account[0].number }}
    </td>
    <td :colspan="7" v-if="item.bank_account[0]">
      صاحب حساب : {{ item.bank_account[0].owner }}
    </td>
    <td :colspan="9" v-else>
      -
    </td>
  </template>
</v-data-table>
</template>
<!-- show-select v-model="selected" -->
<script>
export default {
  name: "table-list",
  props: ['loading', 'headers', 'data', 'showSelect', 'singleSelect'],
  data() {
    return {
      expanded: [],
      singleExpand: true,
      selected: [],
    }
  },
  watch: {
    selected: {
      handler() {
        this.$emit('getSelected', this.selected)
      },
    },
  },
};
</script>

<style lang="scss">
table,
td {
    border: 2px solid lightgray;
    border-collapse: separate;
    font-size: 20px !important;
    // color: blue;
}
th {
    border: 3px solid lightgray;
    border-collapse: inherit;
    font-size: 20px !important;
    background-color: #546E7A !important;
    color: whitesmoke !important;
    // text-align: center;
}
table tr:nth-child(odd) {
    background-color: #fff;
}
table tr:nth-child(even) {
    background-color: #eee;
}
</style>
